import React from "react"
import PropTypes from "prop-types"
import { Button } from "antd"

const TabPill = ({ active, disabled, onClick, className, activeClassName, inactiveClassName, children }) => (
  <Button type="text" disabled={disabled} className={`${className} ${active ? activeClassName : inactiveClassName}`} onClick={onClick}>
    {children}
  </Button>
)

TabPill.propTypes = {
  active: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
  activeClassName: PropTypes.string.isRequired,
  inactiveClassName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

TabPill.defaultProps = {
  disabled: false
}

export default TabPill
